import * as React from "react";
const SvgFiRrDiceD10 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dice-d10_svg__a)">
      <path
        fill="#062147"
        d="M23 12.917a5.06 5.06 0 0 0-1.048-3.24L15.1 1.47a4 4 0 0 0-6.19-.007L2.024 9.709A4.98 4.98 0 0 0 1 12.919a5.25 5.25 0 0 0 1.374 3.267l6.754 6.596A3.96 3.96 0 0 0 12.006 24a3.95 3.95 0 0 0 2.853-1.2l6.794-6.65A5.16 5.16 0 0 0 23 12.918m-2.61-1.993c.201.263.357.557.462.87l-4.108-.684-2.93-8.064zm-8.38 2.827-2.816-2.106 2.812-7.717 2.8 7.718zM10.2 3.046 7.26 11.11l-4.116.69c.1-.303.25-.587.443-.84zM3.808 14.788a3 3 0 0 1-.61-.973l4.545-.758 3.265 2.444v6.23a2.1 2.1 0 0 1-.459-.362zm9.637 6.6q-.194.201-.437.342V15.5l3.25-2.443 4.552.758c-.132.348-.33.666-.583.939z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dice-d10_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiceD10;
